import { ApiClient } from "@/api-client/src/core/api-client";
import { AddUserCartResponse, UserCartResponse } from "@/packages/types/cart";

const apiClient = new ApiClient();
const webService = apiClient.web;

export const fetchUserCarts = async (): Promise<UserCartResponse> => {
  const response = await webService.get<UserCartResponse>(`/users/cart`);
  return response;
};

export interface CartItemApiPost {
  productId: number | string;
  quantity: number;
  variantId?: number | null;
}

export type AddUserCartRequest = CartItemApiPost | CartItemApiPost[];

export const toAddUserCart = async (
  payload: AddUserCartRequest
): Promise<AddUserCartResponse> => {
  const response = await webService.post<AddUserCartResponse>(
    `/users/cart`,
    payload
  );
  return response;
};
export const toDeleteUserCart = async (data: {
  productId: number | string;
  variantId: number | null;
}): Promise<AddUserCartResponse> => {
  const response = await webService.post<AddUserCartResponse>(
    `/users/cart-delete`,
    data
  );
  return response;
};

export const toClearUserCart = async (): Promise<AddUserCartResponse> => {
  const response = await webService.post<AddUserCartResponse>(
    `/users/cart-clear`
  );
  return response;
};
